<template>
  <v-toolbar
    class="app-bar"
    :class="{ 'app-bar_borderless': borderless }"
    flat
  >
    <v-btn
      v-if="hasBackButton"
      size="24"
      data-qa="app-toolbar-back-btn"
      icon="ui-icon-arrow-back"
      exact
      @click="emit('click:back')"
    />
    <v-btn
      v-if="hasCloseButton"
      data-qa="app-toolbar-close-btn"
      icon="ui-icon-close-not-a-circle"
      exact
      @click="emit('click:close')"
    />
    <v-toolbar-title
      v-if="title"
      class="text-h6"
      data-qa="app-toolbar-title"
    >
      <template #text>
        <span class="text-h6">{{ title }}</span>
      </template>
    </v-toolbar-title>
  </v-toolbar>
</template>

<script setup lang="ts">
/**
 * Является оберткой v-toolbar. Служит для отображения тулбара для диалогового окна.
 */

import { useTheme } from 'vuetify'

defineProps({
  /** Заголовок для диалога. */
  title: { type: String, required: true },

  /** Определяет, есть ли у тулбара кнопка "Назад". */
  hasBackButton: { type: Boolean, default: false },

  /** Определяет, есть ли у тулбара кнопка "Закрыть". */
  hasCloseButton: { type: Boolean, default: false },

  /** Определяет, отсутствует ли нижняя граница у тулбара. */
  borderless: { type: Boolean },
})

const emit = defineEmits(['click:back', 'click:close'])

const theme = useTheme()
const borderColor = computed(() => theme.current.value.dark
  ? theme.themes.value.dark.colors['ui-kit-bg-gray-40']
  : theme.themes.value.light.colors['ui-kit-bg-gray-60'])

</script>

<style lang="scss" scoped>
.app-bar {
  border-bottom: 1px solid v-bind(borderColor);

  &_borderless {
    border-bottom: 0;
  }
}
</style>
